module.exports = __webpack_public_path__ + "static/media/BusinessSettings.fa6ed637.svg";